import { render, staticRenderFns } from "./OrderDetailsIndex.vue?vue&type=template&id=84d76e98&scoped=true&"
import script from "./OrderDetailsIndex.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsIndex.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsIndex.vue?vue&type=style&index=0&id=84d76e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d76e98",
  null
  
)

export default component.exports